import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { useAlertContext } from '..';
import { always, defaultTo } from 'rambda';
import { compose as lcompose } from 'lodash/fp';
import { useState } from 'react';

export function Alert() {
  const {
    alert: {
      title,
      message,
      isOpen,
      okAction,
      cancelAction,
      onOk,
      onCancel,
      ok,
      cancelLabel,
      ackCheckBox,
    },
    setAlert,
  } = useAlertContext();

  const [isChecked, setIsChecked] = useState(false);

  const handleClose = (a: boolean) => {
    setAlert(b => ({ ...b, isOpen: false, isOk: a }));

    a ? onOk() : onCancel();
  };

  //TODO should maxWidth configurable?

  return (
    (!ackCheckBox ?
      <Dialog
        open={isOpen}
        onClose={(event, reason) =>
          ['backdropClick', 'escapeKeyDown'].indexOf(reason) === -1
        }
        // maxWidth="sm"
        maxWidth="md"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <div id="alert-dialog-description">{message()}</div>
        </DialogContent>
        <DialogActions>
          {cancelAction && (
            <Button onClick={handleClose.bind(null, false)} variant="contained">
              {cancelLabel}
            </Button>
          )}
          {okAction &&
            lcompose(
              defaultTo(
                always(
                  <Button
                    onClick={handleClose.bind(null, true)}
                    variant="contained"
                    color="primary"
                    autoFocus>
                    ok
                  </Button>
                )
              ),
              always(ok)
            )()()}
        </DialogActions>
      </Dialog> :
      <Dialog
        open={isOpen}
        onClose={(event, reason) =>
          ["backdropClick", "escapeKeyDown"].indexOf(reason) === -1
        }
        maxWidth="md"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <div id="alert-dialog-description">{message()}</div>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                name="acknowledge"
              />
            }
            label="I have read the message and understand I need to check my email to proceed in this process"
          />
        </DialogContent>
        <DialogActions>
          {cancelAction && (
            <Button onClick={() => handleClose(false)} variant="contained">
              {cancelLabel}
            </Button>
          )}
          {okAction &&
            lcompose(
              defaultTo(
                always(
                  <Button
                    onClick={() => handleClose(true)}
                    variant="contained"
                    color="primary"
                    autoFocus
                    disabled={!isChecked}
                  >
                    ok
                  </Button>
                )
              ),
              always(ok)
            )()()}
        </DialogActions>
      </Dialog>)
  );
}
